import React from 'react';
import SimpleInput from '../SimpleInput';

const OpenTextQuestion = ({value, onChange, error, disabled}) => (
    <SimpleInput inputType="multiline" rows={3} disabled={disabled} value={value ?? ''} onChangeCallback={onChange} status={error ? 'error' : null} />
);

export default OpenTextQuestion;
